import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../component/common/Header';
import moment from 'moment'
import NumberFormat from 'react-number-format';

import Shimmer from '../../component/common/Shimmer';
import Loader from '../../component/common/Loader';

import CONSTANT from '../../constant';
import { onChange, validateForm, getStorage } from '../../utils';
import { getLeaveSummary } from '../../actions/LeaveAction';
import { addDetail } from '../../actions/EncashmentAction';


class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const assignedToOptions = getStorage(CONSTANT.cookie.recipients).sort(this.onCompare);
        this.state = {
            assignedTo: { name: 'assignedTo', value: '', error: '', isRequired: true, options: assignedToOptions },
            numberOfDays: { name: 'numberOfDays', value: '', error: '', isRequired: true },
            leaveSummary: undefined,
            showLoader: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.leave;

        const dt = new Date();
        getLeaveSummary(dt.getFullYear()).then((res: any) => {
            this.setState({ leaveSummary: res.result.leaveTypeList })
        });
    }

    render() {
        const { assignedTo, numberOfDays } = this.state;
        const { leaveSummary, showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row my-3">
                            <div className="col-md-8">
                                <h1 className="page-title">Leave Encashment Form</h1>
                            </div>
                            <div className="col-md-4">
                                <Link to={CONSTANT.component.userLeaveList.url} className="btn btn-sm btn-link float-right">Go Back</Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Send this application to <small>*</small></label>

                                                    <select
                                                        value={assignedTo.value}
                                                        className={assignedTo.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        onChange={this.onChange}
                                                        name={assignedTo.name}>
                                                        <option value="">Select an Employee</option>
                                                        {
                                                            assignedTo.options.map((item: any, index: number) => {
                                                                return <option key={index} value={item.code}>{item.name} ({item.employeeNumber})</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Number of Days </label>
                                                    <NumberFormat
                                                        disabled={leaveSummary === undefined}
                                                        maxLength={5}
                                                        allowNegative={false}
                                                        type="text"
                                                        className={numberOfDays.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        placeholder="Number of Days"
                                                        name={numberOfDays.name}
                                                        value={numberOfDays.value}
                                                        onChange={this.onChange}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-3">
                                                <Link to={CONSTANT.component.userLeaveEncashmentList.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                            </div>
                                            <div className="col-md-6">
                                                &nbsp;
                                            </div>
                                            <div className="col-md-3">
                                                <button type="submit" onClick={this.onSubmit} className="btn btn-block submit-button btn-sm">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4">
                                <div className="card mb-3">
                                    <div className="card-header">
                                        Leaves Balance
                                    </div>
                                    <div className="card-body">
                                        <ul className="pl-3 mb-0">
                                            {
                                                leaveSummary !== undefined && leaveSummary.filter((item: any) => item.code !== CONSTANT.static.leaveType.cml).map((i: any, index: any) => {
                                                    const balance = i.total - i.used - i.pending;
                                                    const isNumber = balance % 1 === 0;
                                                    return <li key={index}>
                                                        <span className="mr-1">{i.name}</span>-<strong className="mx-1">{isNumber ? balance : balance.toFixed(2)}</strong> Day(s)
                                                    </li>
                                                })
                                            }
                                        </ul>
                                        {
                                            leaveSummary === undefined && <Shimmer />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            showLoader && <Loader />
                        }
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        
        e.preventDefault();

        if (validateForm(this) && this.validateLeaveBalance()) {
            this.setState({ showLoader: true });
            const st = this.state;
            const model = {
                assignedTo: st.assignedTo.value,
                numberOfDays: st.numberOfDays.value,
            };

            addDetail(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res.status === CONSTANT.static.apiStatus.success) {
                    alert('Your leave request has been successfully posted.');
                    this.props.history.push(CONSTANT.component.userLeaveEncashmentList.url);
                } else {
                    alert(res.error);
                }
            });
        }
    }

    validateLeaveBalance = () => {
        const { numberOfDays, leaveSummary } = this.state;
        let dayCount = numberOfDays.value;

        const elBalance = leaveSummary.filter((j: any) => j.code === CONSTANT.static.leaveType.el);
        const balance = (elBalance[0].total - elBalance[0].used - elBalance[0].pending)

        if (balance < dayCount) {
            alert(`Sorry, You dont have sufficient balance for leave encashment`);
            return false;
        }

        return true;
    }

    onCompare = function (a: any, b: any) {
        let comparison = 0;
        if (a.name > b.name) {
            comparison = 1;
        } else if (a.name < b.name) {
            comparison = -1;
        }
        return comparison;
    }
}

export default ComponentName;